module.exports = __webpack_public_path__ + "static/media/man_with_computer.945a479e.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/man_with_computer.svg
// module id = 1406
// module chunks = 0